
export default class ModelArray extends Array {

    constructor(data = [], Model) {
        var models = data &&  typeof data.map === 'function' ? data.map((d)=>!(d instanceof Model) ? new Model(d) : d) : [];
        super(...models);
    }

}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/ModelArray.js